/**
 * Syntax Highlight Nano 管理画面用JavaScript
 */

// WordPress i18n グローバル変数を使用
const { __ } = wp.i18n;

document.addEventListener("DOMContentLoaded", function () {
  const resetButton = document.getElementById("reset-settings");

  if (!resetButton) {
    return;
  }

  resetButton.addEventListener("click", function (e) {
    e.preventDefault();

    // 確認ダイアログを表示
    if (!confirm(synanoAdmin.strings.confirmReset)) {
      return;
    }

    // ボタンを無効化
    resetButton.disabled = true;
    resetButton.textContent = __("Resetting...", "syntax-highlight-nano");

    // AJAXリクエストを送信
    const formData = new FormData();
    formData.append("action", "synano_reset_settings");
    formData.append("nonce", synanoAdmin.nonce);

    fetch(synanoAdmin.ajaxUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          // 成功メッセージを表示
          showNotice("success", data.data.message);

          // フォームの値を更新
          updateFormValues(data.data.options);

          // プレビューを更新
          updatePreview(data.data.options);

          // デバッグ情報を更新
          updateDebugInfo(data.data.options);
        } else {
          showNotice("error", synanoAdmin.strings.resetError);
        }
      })
      .catch(() => {
        // エラーが発生した場合の処理
        showNotice("error", synanoAdmin.strings.resetError);
        showNotice("error", synanoAdmin.strings.resetError);
      })
      .finally(() => {
        // ボタンを有効化
        resetButton.disabled = false;
        resetButton.textContent = __("Reset Settings", "syntax-highlight-nano");
      });
  });

  /**
   * 通知メッセージを表示
   */
  function showNotice(type, message) {
    // 既存の通知を削除
    const existingNotice = document.querySelector(".synano-notice");
    if (existingNotice) {
      existingNotice.remove();
    }

    // 新しい通知を作成
    const notice = document.createElement("div");
    notice.className = `notice notice-${type} synano-notice is-dismissible`;
    notice.innerHTML = `
            <p>${message}</p>
            <button type="button" class="notice-dismiss">
                <span class="screen-reader-text">${__(
                  "Dismiss this notice",
                  "syntax-highlight-nano"
                )}</span>
            </button>
        `;

    // ページの上部に挿入
    const wrap = document.querySelector(".wrap");
    wrap.insertBefore(notice, wrap.firstChild);

    // 自動で非表示にする（5秒後）
    setTimeout(() => {
      if (notice.parentNode) {
        notice.remove();
      }
    }, 5000);
  }

  /**
   * フォームの値を更新
   */
  function updateFormValues(options) {
    // テーマ
    const themeSelect = document.getElementById("default_theme");
    if (themeSelect) {
      themeSelect.value = options.default_theme;
    }

    // 言語
    const languageSelect = document.getElementById("default_language");
    if (languageSelect) {
      languageSelect.value = options.default_language;
    }

    // ヘッダー表示
    const headerCheckbox = document.getElementById("default_show_header");
    if (headerCheckbox) {
      headerCheckbox.checked = options.default_show_header;
    }

    // 行番号表示
    const lineNumbersCheckbox = document.getElementById(
      "default_show_line_numbers"
    );
    if (lineNumbersCheckbox) {
      lineNumbersCheckbox.checked = options.default_show_line_numbers;
    }
  }

  /**
   * プレビューを更新
   */
  function updatePreview(options) {
    const previewPre = document.querySelector(".preview-container pre");
    if (!previewPre) {
      return;
    }

    // クラスを更新
    previewPre.className = "wp-block-code synano";
    if (options.default_show_line_numbers) {
      previewPre.classList.add("has-line-numbers");
    }
    if (options.default_show_header) {
      previewPre.classList.add("has-header");
    }

    // data属性を更新
    previewPre.setAttribute(
      "data-header",
      getLanguageLabel(options.default_language)
    );
    previewPre.setAttribute("data-theme", options.default_theme);

    // code要素のクラスを更新
    const codeElement = previewPre.querySelector("code");
    if (codeElement) {
      codeElement.className = `language-${options.default_language}`;
    }
  }

  /**
   * デバッグ情報を更新
   */
  function updateDebugInfo(options) {
    const debugPre = document.querySelector(".admin-debug pre");
    if (debugPre) {
      debugPre.textContent = JSON.stringify(options, null, 2);
    }
  }

  /**
   * 言語コードから表示用ラベルを取得
   */
  function getLanguageLabel(language) {
    // PHPから渡された言語ラベル配列を使用
    const labels = window.synanoLanguageLabels || {};

    // マッピングにあればそれを返す、なければそのまま返す
    return labels[language] || language;
  }

  /**
   * テーマ変更時のプレビュー更新
   */
  function updatePreviewTheme(themeName) {
    const previewPre = document.querySelector(".preview-container pre");
    if (!previewPre) {
      return;
    }

    previewPre.setAttribute("data-theme", themeName);

    // 既存のテーマCSSを削除
    const existingThemeLink = document.querySelector(
      "link[data-preview-theme]"
    );
    if (existingThemeLink) {
      existingThemeLink.remove();
    }

    // 新しいテーマCSSを読み込み（ローカルファイルを使用）
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = synanoAdmin.pluginUrl + "dist/themes/" + themeName + ".css";
    link.setAttribute("data-preview-theme", themeName);
    document.head.appendChild(link);
  }

  // テーマ選択の変更イベント
  const themeSelect = document.getElementById("default_theme");
  if (themeSelect) {
    themeSelect.addEventListener("change", function () {
      updatePreviewTheme(this.value);
    });
  }
});
